
 <div class="creative-people-area bg_image--50 ptb--200 ptb-md--80 ptb-sm--80">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="creative-people-inner text-center">
                    <h2 class="heading">Transformación y Expansión 2020</h2><h3><span class="theme-color"> Programa de 21 días</span></h3>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Info del curso -->
<div class="bk-number-speaks section-ptb-xl bg_image--3">
    <div class="container">
        <div class="row">

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12">
                <div class="number-speaks">
                    <div class="content wow move-up">
                        <h3 class="theme-color"><p class="fuente24">¿QUÉ INCLUYE?</p></h3>
                        <p><span class="secondary-color"><li class="fuente24">Acceso a plataforma E-Learning</li>
                                                         <li class="fuente24">21 audios (21 temas)</li>  
                                                          <li class="fuente24">Manual Guía PDF</li> 
                                                           
                                                             <li class="fuente24">Videos</li> </span>
                                                          </p>
                        <div class=""> <br><img src="img/about/landing-icon.png" alt="Brook Preloader"></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12 mt_md--40 mt_sm--40">
                <div class="speakers-number-wrap">

                    <!-- Start Single Count -->
                    <div class="wow move-up">
                        <h1><span class=" theme-color">$900 MXN</span></h1>
                        <div class="content">
                            <h4>Estar mejor? Sentirte pleno(a)? Sentirte en equilibrio? Sabes cómo hacerlo? Esto es para ti!
estás listo(a) para recibir?</h4>
                            <p>
                            <li>Cierre y apertura de nuevos Ciclos </li>
                            <li>El principio del Dar: principios de Luz </li>
                            <li>El gran Observador</li>
                            <li>Tu relación con los campos N + 1</li>
                            <li>Tu Relación con el Dinero </li>
                            <li>Tu relación con el Amor </li>
                            <li>Tu relación con el Tiempo </li>
                            <li>Tu relación con la Abundancia </li>
                            <li>Integración del Tiempo en las Redes</li>
                            <li>Se un emprendedor,  negociador y/o facilitador efectivo </li>
                            <li>Construye, personaliza y programa tu agenda y plan de acción. </li>
                            </p>
                            <p>Equilibrio, transformación, expansión, vínculos,bienestar, salud, plenitud y amor</p>
                            <p>*Formas de pago: PayPal y/o a meses sin intereses, compropago, transferencia, deposito, etc.</p>
                            <p>*📱Informes y Reservas: 961 181 16 08, 554 160 01 37</p>
                            <br> 
                            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="FW28S9VF4F7P8">
<input type="image" src="https://www.paypalobjects.com/es_XC/MX/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal, la forma más segura y rápida de pagar en línea.">
<img alt="" border="0" src="https://www.paypalobjects.com/es_XC/i/scr/pixel.gif" width="1" height="1">
</form>

                        </div>
                    </div>
                    <!-- End Single Count -->

                </div>
            </div>
        </div>
    </div>
</div>